import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { pagesActions, pagesApiActions } from "../actions/pages.actions";
import { map, of, switchMap, withLatestFrom } from "rxjs";
import { selectPrivacyPolicy, selectTerms } from "../selectors/pages.selectors";
import { SitePagesService } from "../../site-pages.service";

@Injectable()
export class PagesEffects {
    private action$ = inject(Actions);
    private service = inject(SitePagesService);
    private store = inject(Store);

    fetchTerms$ = createEffect(() => {
        return this.action$.pipe(
            ofType(pagesActions.getTerms),
            withLatestFrom(this.store.select(selectTerms)),
            switchMap((action,data) =>{
                if (data){
                    return of()
                }
                else{
                    return this.service.getTerms().pipe(
                        map(response => pagesApiActions.fetchPage({ page: response}))
                    )
                }
            })
        )
    })

    fetchPrivacy$ = createEffect(() => {
        return this.action$.pipe(
            ofType(pagesActions.getPrivacyPolicy),
            withLatestFrom(this.store.select(selectPrivacyPolicy)),
            switchMap((action,data) =>{
                if (data){
                    return of()
                }
                else{
                    return this.service.getPrivacyPolicy().pipe(
                        map(response => pagesApiActions.fetchPage({ page: response}))
                    )
                }
            })
        )
    })
}